import { render } from "./SimDetails.vue?vue&type=template&id=23188346"
import script from "./SimDetails.vue?vue&type=script&lang=js"
export * from "./SimDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__